import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicNoMessage({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 48 48"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M41.77 11.5a5.5 5.5 0 015.5 5.5v18.62a5.5 5.5 0 01-5.5 5.5h-3.12v3.47a2.5 2.5 0 01-4.26 1.76l-5.24-5.23H15a5.5 5.5 0 01-5.5-5.5V17a5.5 5.5 0 015.5-5.5h26.77zm0 3H15a2.5 2.5 0 00-2.5 2.5v18.62a2.5 2.5 0 002.5 2.5h14.77c.4 0 .78.15 1.06.43l4.82 4.83v-3.76c0-.83.68-1.5 1.5-1.5h4.62a2.5 2.5 0 002.5-2.5V17a2.5 2.5 0 00-2.5-2.5zM34 2.5A5.5 5.5 0 0139.5 8a1.5 1.5 0 01-3 0v-.16A2.5 2.5 0 0034 5.5H6A2.5 2.5 0 003.5 8v22A2.5 2.5 0 006 32.5h.14a1.5 1.5 0 01-.14 3A5.5 5.5 0 01.5 30V8A5.5 5.5 0 016 2.5zm-2.77 26a1.5 1.5 0 110 3H18.38a1.5 1.5 0 010-3zm6.92-7.38a1.5 1.5 0 010 3H18.38a1.5 1.5 0 010-3z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgPicNoMessage.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicNoMessage.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgPicNoMessage svgRef={ref} {...props} />);
export default ForwardRef;
